import type { TDataExportStoreState } from 'App/data-export/store/dataExportStore'
import { intervalAndValueTypesOptions } from 'App/data-export/store/selectors/intervalAndValueTypesOptions'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'

export const adjustIntervalAndValueTypesForFormState = ({
  formState,
  fieldAssetStoreState,
}: {
  formState: TDataExportStoreState['formState']
  fieldAssetStoreState: TFieldAssetStoreState
}) => {
  const newSelection = intervalAndValueTypesOptions({
    propertyId: formState.propertyId,
    points: formState.points,
    blockIds: formState.blockIds,
    irrigationZoneEmitterIds: formState.irrigationZoneEmitterIds,
    interval: formState.interval,
    fieldAssetStoreState: fieldAssetStoreState,
  })

  // keep the same interval if it's still valid for the new state selection
  const interval = newSelection.intervalOptions.some((item) => item.id === formState.interval)
    ? formState.interval
    : null

  // only keep the value types that are still valid for the new state selection
  const valueTypes =
    interval === null
      ? []
      : formState.valueTypes.reduce<string[]>((acc, valueType) => {
          if (newSelection.valueTypesOptions.some((item) => item.valueType === valueType)) {
            acc.push(valueType)
          }

          return acc
        }, [])

  return {
    ...formState,
    interval: interval,
    valueTypes: valueTypes,
  }
}
